import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { editaTurnosDisponibles } from "../../../context/Actions/turnos/turnosDisponibles";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import camelize from "../../../../global/utils/camelize";
import DropdownCheck from "../../Genericos/DropdownCheck/DropdownCheck";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./FiltrosTurnos.css";
import { parseFiltros } from "../../../../global/utils/parseFilter";

const FiltrosTurnos = ({
  titulo,
  dissmiss,
  handleClickBuscar,
  handleClickProximos,
  handleChangeDatePicker,
  flgExcedeBusq,
  fecha,
  ofertasTurnos,
}) => {
  const { turnosDisponiblesState, turnosDisponiblesDispatch } =
    useContext(PortalContext);

  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  useEffect(() => {
    if (!ofertasTurnos) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen !==
        "LABORATORIO"
      ) {
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0
        ) {
          let centro = [
            ...new Set(
              turnosDisponiblesState.turnosDisponibles.turnosData.turnos.map(
                (item) => item.centro
              )
            ),
          ];
          const map = new Map();
          for (const item of centro) {
            if (
              !turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centros.filter(
                (x) => x.descripcion === item
              ).length > 0
            ) {
              if (!map.has(item)) {
                map.set(item);
                //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
                const lastItem =
                  turnosDisponiblesState.turnosDisponibles.turnosData
                    .filtrosData.centros[
                    turnosDisponiblesState.turnosDisponibles.turnosData
                      .filtrosData.centros.length - 1
                  ];
                turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centros.push(
                  {
                    id: lastItem.id + 1,
                    descripcion: item,
                    checked: true,
                  }
                );
              }
            }
          }
        }
      }
    }
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.turnos]);

  useEffect(() => {
    if (!ofertasTurnos) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.turnos.length > 0
      ) {
        let especialistas = [
          ...new Set(
            turnosDisponiblesState.turnosDisponibles.turnosData.turnos.map(
              (item) => (item.medico !== null ? item.medico : item.recepcion)
            )
          ),
        ];
        const map = new Map();
        for (const item of especialistas) {
          if (
            !turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.especialistas.filter(
              (x) => camelize(x.descripcion) === camelize(item)
            ).length > 0
          ) {
            if (!map.has(item)) {
              map.set(item);
              const lastItem =
                turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                  .especialistas[
                  turnosDisponiblesState.turnosDisponibles.turnosData
                    .filtrosData.especialistas.length - 1
                ];
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.especialistas.push(
                {
                  id: lastItem.id + 1,
                  descripcion: camelize(item),
                  checked: true,
                }
              );
            }
          }
        }
      }
    }
  }, [turnosDisponiblesState.turnosDisponibles.turnosData.turnos]);

  // const handleChangeCentros = (e) => {

  //   let centroArrx =
  //   turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.centros;
  //   //manejo el estado de los botones
  //   if (e.target.id === "0" && !e.target.checked) {
  //     centroArrx = centroArrx.map((array) => ({ ...array, checked: false }));
  //   } else if (e.target.id === "0" && e.target.checked) {
  //     centroArrx = centroArrx.map((array) => ({ ...array, checked: true }));
  //   } else if (e.target.id !== "0") {
  //     let objIndex = centroArrx.findIndex(
  //       (obj) => obj.id.toString() === e.target.id
  //     );
  //     centroArrx[objIndex].checked = e.target.checked;
  //     //no se cumple la funcion de todos. Destildo.
  //     centroArrx[0].checked = false;
  //     if (!centroArrx[0].checked) {
  //       let centroAux = centroArrx.filter((item) => item.checked !== true);
  //       if (
  //         centroAux.length === 1 &&
  //         centroAux.filter((item) => item.id === 0).length > 0
  //       ) {
  //         centroArrx[0].checked = true;
  //       }
  //     }
  //   }
  //   // este editar lo deja vacio sin editar.
  //   editaTurnosDisponibles({
  //     ...turnosDisponiblesState.turnosDisponibles.turnosData,
  //     filtrosData: {
  //       ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
  //       centros: centroArrx,
  //     },
  //   })(turnosDisponiblesDispatch);
  // };

  const handleChangeCentros = (centroArrx) => {
    let origenLabo =
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "LABORATORIO";
    if (origenLabo) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centrosLabo: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    } else {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        filtrosData: {
          ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
          centros: centroArrx,
        },
      })(turnosDisponiblesDispatch);
    }
  };

  const handleChangeDia = (diaSemArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        diasKin: diaSemArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeRango = (rangoArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        rangoHorario: rangoArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  const handleChangeEspecialista = (espArrx) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        especialistas: espArrx,
      },
    })(turnosDisponiblesDispatch);
  };

  // Esto es para el datePicker
  const noventaDiasDespues = new Date(fecha);
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);
  const diaSelecionado =
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;

  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <div className="ptur-filtrosTurnos-container">
        <div className="ptur-filtrosTurnos-checkCentro-box">
          <DropdownCheck
            customWh={"ptur-filtrosTurnos-checkFecha-boxWh"}
            placeholder={"Centros"}
            boxCheckArrowed={false}
            handleChangeFiltros={handleChangeCentros}
            longitud={
              turnosDisponiblesState.turnosDisponibles.turnosData
                .volverOrigen === "LABORATORIO"
                ? turnosDisponiblesState.turnosDisponibles.turnosData
                    .filtrosData.centrosLabo.length - 1
                : turnosDisponiblesState.turnosDisponibles.turnosData
                    .filtrosData.centros.length - 1
            }
            datos={
              turnosDisponiblesState.turnosDisponibles.turnosData
                .volverOrigen === "LABORATORIO"
                ? turnosDisponiblesState.turnosDisponibles.turnosData
                    .filtrosData.centrosLabo
                : turnosDisponiblesState.turnosDisponibles.turnosData
                    .filtrosData.centros
            }
          />
        </div>
        <div className="ptur-filtrosTurnos-checkFecha-box">
          <DatePicker
            fechaInicial={`${fecha.getFullYear()} ${
              fecha.getMonth() + 1
            } ${fecha.getDate()}`}
            selectedFecha={`${!diaSelecionado ? "" : diaSelecionado}`}
            fechaFinal={`${fechaLimte.getFullYear()} ${
              fechaLimte.getMonth() + 1
            } ${fechaLimte.getDate()}`}
            onChange={handleChangeDatePicker}
            customCss={"ptur-headerBarFiltros-filtros-datePicker"}
          />
        </div>
        <div className="ptur-filtrosTurnos-checkDia-box">
          <DropdownCheck
            customWh={"ptur-filtrosTurnos-checkFecha-boxWh"}
            placeholder={"Día semanal"}
            boxCheckArrowed={false}
            handleChangeFiltros={handleChangeDia}
            longitud={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .diasKin.length - 1
            }
            datos={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .diasKin
            }
          />
        </div>
        <div className="ptur-filtrosTurnos-checkRango-box">
          <DropdownCheck
            customWh={"ptur-filtrosTurnos-checkFecha-boxWh"}
            placeholder={"Horarios"}
            boxCheckArrowed={false}
            handleChangeFiltros={handleChangeRango}
            longitud={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .rangoHorario.length - 1
            }
            datos={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .rangoHorario
            }
          />
        </div>
        <div className="ptur-filtrosTurnos-checkEspecialista-box">
          <DropdownCheck
            customWh={"ptur-filtrosTurnos-checkFecha-boxWh"}
            placeholder={"Especialistas"}
            boxCheckArrowed={false}
            handleChangeFiltros={handleChangeEspecialista}
            longitud={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .especialistas.length - 1
            }
            datos={
              turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
                .especialistas
            }
          />
        </div>
        <div className="ptur-filtrosTurnos-btn-box">
          <button
            className="ptur-filtrosTurnos-btnBuscar c-white rb18m"
            onClick={handleClickBuscar}
          >
            Buscar
          </button>

          <div className="ptur-filtrosTurnos-divsores-box">
            <div className="ptur-filtrosTurnos-divsor"></div>
            <span className="ptur-filtrosTurnos-divsores-txt rb12m">
              o buscar por
            </span>
            <div className="ptur-filtrosTurnos-divsor"></div>
          </div>

          <button
            className="ptur-filtrosTurnos-btnProx c-latex30 rb16m"
            onClick={handleClickProximos}
          >
            {!flgExcedeBusq
              ? "Próximos turnos disponibles"
              : "Reiniciar búsqueda"}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FiltrosTurnos;
